<template>
  <i class="icon" :class="clsName"></i>
</template>

<script>
export default {
  props: {
    clsName: {
      type: String,
      default: '',
    },
  },
};
</script>

<style></style>
